import { Link } from 'react-router-dom';
import { IP_NOTICE_SHORT } from '../../legal/ipNotice';
import { shouldShowDevtools } from '../../devtools';

export function Footer() {
  const showDev = shouldShowDevtools() || !import.meta.env.PROD;

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-row">
          <span className="footer-notice">{IP_NOTICE_SHORT}</span>
        </div>
        <div className="footer-row footer-links-row">
          <Link to="/legal" className="footer-link">IP & Independence</Link>
          <span className="footer-separator">•</span>
          <span className="footer-copyright">© 2024–{new Date().getFullYear()} Atlas PHM</span>
          {showDev && (
            <>
              <span className="footer-separator">•</span>
              <span className="footer-build-canary" style={{ fontSize: '0.75em', opacity: 0.7 }}>
                Build: {import.meta.env.VITE_APP_NAME || 'unknown'} @ {String(import.meta.env.VITE_GIT_COMMIT || 'dev').slice(0, 7)}
              </span>
              <span className="footer-separator">•</span>
              <Link to="/dev/glass-box?dev=1" className="footer-link">Glass Box</Link>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
